var pt_br = {
    values: {
        'On map': 'No mapa',
        'Settings': 'Configurações',
        'Select a trip': 'Selecione uma viagem',
        'Parameters Settings': 'Configuração de Parâmetros',
        'from the list to see its information': 'da lista para ver as informações dela',
        'Use the Shift key to tilt the map view': 'Use a tecla shift para inclinar a visualização do mapa',
        'You need to have at least 1 parameter selected': 'Você precisa ter pelo menos um parâmetro selecionado',
        "You've selected the maximum number of parameters": "Você já selecionou o número máximo de parâmetros",
        'Event time (UTC-0)': 'Tempo do evento (UTC-0)',
        'Event time (User TZ)': 'Tempo do evento (TZ usuário)'
    }
}

module.exports = pt_br
